"use client";

import React, { useState } from "react";
import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Link } from "@/components/common/Link";
import { ChevronRight } from "lucide-react";
const categories = [{
  title: "Auto",
  description: "Vetture moderne e confortevoli per i tuoi spostamenti urbani o viaggi a lungo raggio.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638728/img/audi.png"
}, {
  title: "Moto",
  description: "Potenza e libertà su due ruote per gli amanti delle prestazioni e del vento sul viso.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638728/img/bella_moto.png"
}, {
  title: "Scooter",
  description: "La soluzione agile e veloce per muoversi nel traffico cittadino senza pensieri.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638728/img/sh_honda_300i.png"
}, {
  title: "E-Bike",
  description: "Pedalata assistita di ultima generazione per esplorare percorsi panoramici senza fatica.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638728/img/category_ebike_person.png"
}, {
  title: "Bike",
  description: "Biciclette muscolari per chi ama il contatto puro con la strada e l'attività fisica.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638728/img/category_bike_person.png"
}, {
  title: "Monopattini Elettrici",
  description: "Micro-mobilità sostenibile e divertente per brevi tragitti urbani in totale libertà.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638728/img/category_scooter_electric.png"
}, {
  title: "Quad/ATV",
  description: "Mezzi robusti e versatili per avventure off-road su ogni tipo di terreno.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638728/img/category_quad.png"
}, {
  title: "Segway/Hoverboard",
  description: "Tecnologia autobilanciante per un modo innovativo e tech di scoprire la città.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638728/img/category_segway.png"
}, {
  title: "Attrezzatura/Accessori",
  description: "Caschi, protezioni e tutto il necessario per la tua sicurezza e il tuo comfort.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638728/img/category_accessories.png"
}];
const subcategories: Record<string, {
  name: string;
  link: string;
}[]> = {
  "Auto": [{
    name: "City Car",
    link: "/EBikeRentalPage"
  }, {
    name: "SUV",
    link: "/EBikeRentalPage"
  }, {
    name: "Luxury",
    link: "/EBikeRentalPage"
  }],
  "Moto": [{
    name: "Sportive",
    link: "/EBikeRentalPage"
  }, {
    name: "Touring",
    link: "/EBikeRentalPage"
  }, {
    name: "Enduro",
    link: "/EBikeRentalPage"
  }],
  "Scooter": [{
    name: "50cc",
    link: "/EBikeRentalPage"
  }, {
    name: "125cc",
    link: "/EBikeRentalPage"
  }, {
    name: "300cc+",
    link: "/EBikeRentalPage"
  }],
  "E-Bike": [{
    name: "Mountain E-Bike",
    link: "/EBikeRentalPage"
  }, {
    name: "City E-Bike",
    link: "/EBikeRentalPage"
  }, {
    name: "Folding E-Bike",
    link: "/EBikeRentalPage"
  }],
  "Bike": [{
    name: "Road Bike",
    link: "/EBikeRentalPage"
  }, {
    name: "Mountain Bike",
    link: "/EBikeRentalPage"
  }, {
    name: "Gravel Bike",
    link: "/EBikeRentalPage"
  }],
  "Monopattini Elettrici": [{
    name: "Standard",
    link: "/EBikeRentalPage"
  }, {
    name: "Pro Performance",
    link: "/EBikeRentalPage"
  }],
  "Quad/ATV": [{
    name: "Utility Quad",
    link: "/EBikeRentalPage"
  }, {
    name: "Sport Quad",
    link: "/EBikeRentalPage"
  }],
  "Segway/Hoverboard": [{
    name: "Segway PT",
    link: "/EBikeRentalPage"
  }, {
    name: "Hoverboard Pro",
    link: "/EBikeRentalPage"
  }],
  "Attrezzatura/Accessori": [{
    name: "Caschi",
    link: "/EBikeRentalPage"
  }, {
    name: "Protezioni",
    link: "/EBikeRentalPage"
  }, {
    name: "Navigatori GPS",
    link: "/EBikeRentalPage"
  }]
};
export default function LimitedEditionCookies() {
  const [openCategory, setOpenCategory] = useState<string | null>(null);
  return <section id="prenota-la-tua-avventura" className="py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <h2 className="font-default text-4xl md:text-5xl font-bold text-foreground mb-6 tracking-tighter uppercase">
            Le Nostre Categorie di Noleggio
          </h2>
          <p className="text-muted-foreground text-lg font-default leading-relaxed">
            Scopri le nostre categorie di noleggio e trova il mezzo perfetto per la tua avventura.
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category, i) => {
          return <React.Fragment key={i}>
                <Card data-index={i} className="bg-card hover:scale-105 transition-all duration-300 shadow-md hover:shadow-lg rounded-lg group overflow-hidden border-0 p-0 cursor-pointer" onClick={() => setOpenCategory(category.title)}>
                  <CardHeader className="p-0 relative">
                    <div className="relative w-full flex items-center justify-center overflow-hidden">
                      <img src={category.imageSrc} alt={category.title} data-wvc-srcset={`${category.imageSrc}-wvc-srcset`} data-wvc-sizes={`${category.imageSrc}-wvc-sizes`} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                      
                      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
                      
                      <div className="absolute bottom-0 left-0 w-full p-6 flex flex-col gap-2">
                        <CardTitle className="font-default text-xl font-bold tracking-tight uppercase text-white">
                          {category.title}
                        </CardTitle>
                        <p className="text-white/80 font-default text-sm leading-relaxed line-clamp-2">
                          {category.description}
                        </p>
                      </div>
                    </div>
                  </CardHeader>
                </Card>

                <Dialog open={openCategory === category.title} onOpenChange={open => !open && setOpenCategory(null)}>
                  <DialogContent className="sm:max-w-md bg-card border-border rounded-lg">
                    <DialogHeader>
                      <DialogTitle className="text-2xl font-bold uppercase tracking-tight text-foreground">
                        {category.title}
                      </DialogTitle>
                    </DialogHeader>
                    <div className="grid gap-4 py-4">
                      {subcategories[category.title]?.map((sub, subIdx) => <Link key={subIdx} to={sub.link} className="flex items-center justify-between p-4 rounded-lg bg-muted hover:bg-primary hover:text-primary-foreground transition-colors group" onClick={() => setOpenCategory(null)}>
                          <span className="font-medium">{sub.name}</span>
                          <ChevronRight className="h-5 w-5 opacity-0 group-hover:opacity-100 transition-opacity" />
                        </Link>)}
                    </div>
                  </DialogContent>
                </Dialog>
              </React.Fragment>;
        })}
        </div>
      </div>
    </section>;
}